import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { BackButton } from '../../../pagelayout/backButton';
import Button from '../../../components/button';
import translations from '../practiceplaceprofile.i18n';

interface ActionItemsProps {
  backPath: string;
  isEditMode: boolean;
  setIsEditMode: (mode: boolean) => void;
  canEdit: boolean;
  cancelEdit: () => void;
  saveEdit: () => void;
}

export const ActionItems: React.FC<
  React.PropsWithChildren<ActionItemsProps>
> = ({
  backPath,
  isEditMode,
  setIsEditMode,
  canEdit,
  cancelEdit,
  saveEdit,
}) => {
  const { formatMessage } = useIntl();
  const labels = useMemo(
    () => ({
      tilbake: formatMessage({ id: translations.tilbake.id }),
      endre: formatMessage({ id: translations.endre.id }),
      avbryt: formatMessage({ id: translations.avbryt.id }),
      lagre: formatMessage({ id: translations.lagre.id }),
    }),
    [formatMessage],
  );

  const editButtons = useMemo(
    () =>
      isEditMode ? (
        <>
          <Button.Primary onClick={cancelEdit}>{labels.avbryt}</Button.Primary>
          <Button.Primary onClick={saveEdit} disabled={false}>
            {labels.lagre}
          </Button.Primary>
        </>
      ) : (
        <Button.Primary onClick={() => setIsEditMode(true)}>
          {labels.endre}
        </Button.Primary>
      ),
    [isEditMode, cancelEdit, saveEdit, setIsEditMode, labels],
  );

  return (
    <>
      <BackButton title={labels.tilbake} path={backPath} />
      {canEdit && editButtons}
    </>
  );
};
